import Lottie from "react-lottie";

const LottieLogo = ({ options, children }: any) => (
  <Lottie options={options} width="10%">
    {children}
  </Lottie>
);

export default LottieLogo;
